<template>
  <div
    class="modal-level-two-container"
    v-if="forceReload"
    style="z-index: 99999999"
  >
    <Loading v-if="$store.state.modalStore.isLoading" />
    <div class="modal-dialog-level-two">
      <div class="modal-content-level-two">
        <div class="btn-modal-close cursor-pointer" @click="closeModal()">
          <i class="fa-solid fa-xmark"></i>
        </div>
        <div class="modal-header">
          <h4 class="modal-title">Kegiatan Usaha Utama</h4>
        </div>
        <div class="modal-filter-search">
          <InputIcons
            :inputClass="'border-input-red'"
            :placeholder="'Cari sub kegiatan usaha utama ...'"
            v-model="subSearch"
          />
        </div>
        <div class="modal-body-level-two" v-if="kbliData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column10">Kode</div>
            <div class="column30 mr10">Keterangan</div>
          </div>
          <div class="horizontal" v-for="(item, index) in kbli" :key="index">
            <div class="column5">
              <input
                class="modal-input-checkbox-level-two"
                type="checkbox"
                :id="index"
                :value="item"
                v-model="choose"
              />
            </div>
            <div class="column15">{{ item.kode }}</div>
            <div class="column80 col-nohover mr10">{{ item.desc }}</div>
          </div>
        </div>

        <div class="modal-body-level-two-mobile" v-if="kbliData">
          <div
            class="modal-content-list"
            v-for="(item, index) in kbli"
            :key="index"
          >
            <div class="column5 mr10">
              <input
                class="modal-input-checkbox-level-two"
                type="checkbox"
                :id="index"
                :value="item"
                v-model="choose"
              />
            </div>
            <div class="column90">
              <div class="w-full text-gray">Kode</div>
              <div class="w-full">{{ item.kode }}</div>
              <div class="w-full text-gray">Keterangan</div>
              <div class="w-full">{{ item.desc }}</div>
            </div>
          </div>
        </div>
        <div class="modal-footer flex-space-between">
          <button type="button" class="btn btn__red" @click="add()">
            Done
          </button>
          <div class="btn btn__default">
            <BtnIcons
              :className="'level1-section-filter__footer-relative'"
              :path="'icon-refresh.png'"
              :title="'Reset'"
              :position="true"
              :colors="true"
              :onClick="onReset"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    Loading: () => import('@/components/utils/Loading'),
    InputIcons: () => import('@/components/Atoms/InputIcons'),
    BtnIcons: () => import('@/components/Atoms/BtnIcons'),
  },
  data() {
    return {
      kbli: [],
      subKbliMaster: [],
      choosedKbli: [],
      subSearch: '',
      delKbli: [],
      addKbli: [],
      forceReload: true,
    }
  },
  computed: {
    choose: {
      get: function() {
        return this.$store.state.searchStore.choosedKbli
      },
      set(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedKbli',
          value: newValue,
        })
      },
    },
    kbliData: function() {
      return this.setUpData()
    },
  },
  watch: {
    subSearch: function(newValue, oldValue) {
      this.searchRun()
    },
  },
  methods: {
    async onReset() {
      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedKbli',
        value: [],
      })
    },
    async add() {
      console.log('subsearch done: ', this.subSearch)
      console.log('add kbli', this.$store.state.searchStore.choosedKbli)
      await this.closeModal()
    },
    async searchRun(id) {
      const search = String(this.subSearch)
      const list = this.subKbliMaster

      let filteredList = []
      for (let i in list) {
        if (list[i].desc.toLowerCase().indexOf(search.toLowerCase()) != -1) {
          filteredList.push(list[i])
        }
      }

      this.kbli = filteredList
    },
    resetPlaceholder() {
      this.subSearch = ''
      this.subKbli = this.subKbliMaster
    },
    async setUpData() {
      await this.$store.commit('modalStore/setValue', {
        name: 'isLoading',
        value: true,
      })
      const getKbli = await this.$getKbli()
      const defaultKbli = await this.$store.state.level1.choosedKbli
      console.log('default kbli: ', defaultKbli)

      let reduceKbli = await getKbli.reduce(
        (a, b) => ({ ...a, [b.kode]: b }),
        {}
      )

      let reduceDefault =
        (await defaultKbli) &&
        defaultKbli.reduce((a, b) => ({ ...a, [b.kode]: b }), {})

      let combine = { ...reduceKbli, ...reduceDefault }

      let newKbli = await Object.values(combine)

      this.kbli = await newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.subKbliMaster = newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.choosedKbli = await defaultKbli.map(list => {
        return list.id
      })

      await this.$store.commit('modalStore/setValue', {
        name: 'isLoading',
        value: false,
      })
    },
    async closeModal() {
      this.$store.commit('modalStore/closeModal', {
        name: 'kbli',
      })
    },
  },
}
</script>
